var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact/Pricing-_Parameters_TExpanded",
    transform: "translate(-1281.000000, -173.000000)",
    fill: "#335498",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book-filter",
    transform: "translate(1152.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "currency-all"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rubbish-bin-delete-button-copy-2",
    transform: "translate(129.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.714285714,10.6666667 C0.714285714,11.4 1.35714286,12 2.14285714,12 L7.85714286,12 C8.64285714,12 9.28571429,11.4 9.28571429,10.6666667 L9.28571429,2.66666667 L0.714285714,2.66666667 L0.714285714,10.6666667 Z M10,0.666666667 L7.5,0.666666667 L6.78571429,0 L3.21428571,0 L2.5,0.666666667 L0,0.666666667 L0,2 L10,2 L10,0.666666667 Z",
    id: "Shape"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bin.83d5c4c0.svg";
export { ForwardRef as ReactComponent };